import { expVal } from '@confluence/feature-experiments';
import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder.ts';

import { useIsDarkMode } from './useIsDarkMode.ts';
import { getCustomTheme, type CustomThemeResult } from './getCustomTheme.ts';

export const useCustomTheme = (
	backgroundColorRaw: string | null | undefined,
	highlightColorRaw: string | null | undefined,
): CustomThemeResult => {
	const isDarkMode = useIsDarkMode();
	const renderServerPlaceholder = useRenderServerPlaceholder();
	const useServerValue =
		renderServerPlaceholder &&
		expVal('confluence_frontend_fix_topnav_styling_hydration', 'isEnabled', false);
	return getCustomTheme({ backgroundColorRaw, highlightColorRaw, isDarkMode, useServerValue });
};
